// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".role-permissions__submit-bar {\n  float: right;\n}\n.role-permissions__submit-button .v-btn__content {\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
